import Tooltip from '@mui/material/Tooltip';
import intl from 'react-intl-universal';
import DatePicker from './DatePicker';
import { isWithinInterval, startOfDay, endOfDay } from 'date-fns';
import Typography from '@mui/material/Typography';

const FromToDatePicker = (props: any) => {
  return [
    <Tooltip key={'tooltip-from'} title={intl.get('board.toolbar.date.from.tooltip')}>
      <DatePicker
        field={{
          id: 'dateFrom',
        }}
        minDate={props.minDateFrom}
        maxDate={props.maxDateFrom}
        value={props.valueFrom}
        handleChange={props.handleChange}
        sx={{ marginRight: '8px', width: '130px' }}
        showTodayButton={isWithinInterval(Date.now(), {
          start: startOfDay(props.minDateFrom),
          end: endOfDay(props.maxDateFrom),
        })}
        autoOk
        clearable={false}
      />
    </Tooltip>,
    <Typography key={'arrow'} variant="subtitle1">
      {'->'}
    </Typography>,
    <Tooltip key={'tooltip-to'} title={intl.get('board.toolbar.date.to.tooltip')}>
      <DatePicker
        field={{
          id: 'dateTo',
        }}
        minDate={props.minDateTo}
        maxDate={props.maxDateTo}
        value={props.valueTo}
        handleChange={props.handleChange}
        sx={{ marginLeft: '8px', width: '130px' }}
        showTodayButton={isWithinInterval(Date.now(), {
          start: startOfDay(props.minDateTo),
          end: endOfDay(props.maxDateTo),
        })}
        autoOk
        clearable={false}
      />
    </Tooltip>,
  ];
};

export default FromToDatePicker;
